<template>
  <div class="shopmarketing">
    <div
      class="flex between"
      style="padding-right: 20px"
    >
      <div class="page_title"> 医生开方活动统计详情 — {{doctor_name}}
      </div>
      <el-button
        type="primary"
        size="medium"
        @click="back"
        style="width: 120px"
      >返回</el-button>
    </div>
    <div style="padding:20px;">
      <div class="flex_between header">
        <div class="item">
          <div>
            <span class="green">{{count_data.total_num}}</span>
            <span>({{count_data.total_num_no_settle}})</span>
          </div>
          <div class="top_title">
            总开方量
          </div>
        </div>
        <div class="item">
          <div>
            <span class="green">{{count_data.total_up_num}}</span>
            <span>({{count_data.total_up_num_no_settle}})</span>
          </div>
          <div class="top_title">
            达标总开方量
          </div>
        </div>
        <div
          class="item"
          style="width:22%"
        >
          <div>
            <span
              class="green">￥{{count_data.total_pre_money?count_data.total_pre_money.toFixed(2):0}}</span>
            <span>({{count_data.total_pre_money_no_settle?count_data.total_pre_money_no_settle.toFixed(2):0}})</span>
          </div>
          <div class="top_title">
            开方总金额
          </div>
        </div>
        <div
          class="item"
          style="width:22%"
        >
          <div>
            <span
              class="green">￥{{count_data.total_dug_money?count_data.total_dug_money.toFixed(2):0}}</span>
            <span>({{count_data.total_dug_money_no_settle?count_data.total_dug_money_no_settle.toFixed(2):0}})</span>
          </div>
          <div class="top_title">
            药费总金额
          </div>
        </div>
        <div
          class="item"
          style="width:20%"
        >
          <div>
            <span class="green">￥{{count_data.total_awards_money}}</span>
            <span>({{count_data.total_awards_money_no_settle}})</span>
          </div>
          <div class="top_title">
            奖励总额
          </div>
        </div>
      </div>
      <div class="container">
        <div style="margin-bottom: 30px;">
          <div class="title">备注信息</div>
          <div>
            <el-input
              v-model="remark"
              style="width:800px;margin-right:20px"
              maxlength="50"
              clearable=""
            ></el-input>
            <el-button
              type="primary"
              @click="setRemark"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1021') : false
              "
            >保存</el-button>
          </div>
        </div>
        <div class="title">活动奖励详情</div>
        <div
          class="list_item"
          v-for="(item,index) in list"
          :key="index
        "
        >
          <div class="flex_between">
            <div>
              <span class="item_title">
                奖励名称
              </span>
              <span>
                {{item.rule_name}}
              </span>
            </div>
            <div>
              <el-tag
                type="success"
                v-if="item.status=='已完成'"
              >已完成</el-tag>
              <el-tag
                type="danger"
                v-if="item.status=='未完成'"
              >未完成</el-tag>
            </div>
          </div>
          <div style="margin-top:10px">
            <span class="item_title">
              结算条件
            </span>
            <span>
              {{item.act_type}}
            </span>
          </div>
          <div style="margin-top:10px">
            <span class="item_title">
              奖励类型
            </span>
            <span>
              {{item.reward_type}}
            </span>
          </div>
          <div
            style="margin-top:10px"
            v-if="item.status=='已完成'"
          >
            <span class="item_title">
              奖励信息
            </span>
            <span v-if="item.remark">
              {{item.remark}}
            </span>
            <span v-else>
              暂未选择奖励
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      count_data: {},
      act_id: this.$route.query.act_id,
      doctor_name: this.$route.query.doctor_name,
      doctor_id: this.$route.query.doctor_id,
      remark: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getDetail() {
      let data = {
        act_id: this.act_id,
        doctor_id: this.doctor_id
      };
      this.axios
        .post('platform/doctor/doctorActivityCountDetail', data)
        .then((res) => {
          if (res.code == 0) {
            this.count_data = res.data.count_data;
            this.list = res.data.data;
            this.remark = res.data.remark;
          }
        });
    },
    //备注
    setRemark() {
      let data = {
        act_id: this.act_id,
        doctor_id: this.doctor_id,
        remark: this.remark
      };
      this.axios
        .post('platform/doctor/doctorActivityRemark', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.getDetail();
          }
        });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 280px);
  margin-top: 20px;
  text-align: left;
}
.header {
  .item {
    width: 14%;
    height: 120px;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    align-items: center;
    .icon {
      width: 70px;
      height: 70px;
      margin: 0 20px;
    }
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .green {
      color: #669961;
      font-size: 30px;
      font-weight: 700;
      margin-right: 5px;
    }
    .top_title {
      font-weight: 700;
      margin-top: 5px;
    }
  }
}
.title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
}
.list_item {
  width: 500px;
  background: #f5f5f5;
  padding: 20px;
  margin-bottom: 16px;
  border-radius: 10px;
  .item_title {
    font-weight: 700;
    margin-right: 16px;
  }
}
</style>